import { render, staticRenderFns } from "./trainManage.vue?vue&type=template&id=281b8bd2&scoped=true"
import script from "./trainManage.vue?vue&type=script&lang=js"
export * from "./trainManage.vue?vue&type=script&lang=js"
import style0 from "./trainManage.vue?vue&type=style&index=0&id=281b8bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281b8bd2",
  null
  
)

export default component.exports